import { FC, ReactNode, useEffect } from 'react'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { type Config, useAccount, WagmiProvider } from 'wagmi'
import { watchAccount } from 'wagmi/actions'

import { normalizeEip1193ChainIdConnector } from 'utils/normalizeEip1193ChainId'
import { getWalletConnectionState } from 'utils/walletConnectionState'

type Props = {
  children: ReactNode
  config: Config
}

const queryClient = new QueryClient()

const Eip1193ChainIdNormalizer: FC<Pick<Props, 'config'>> = ({ config }) => {
  const { connector } = useAccount()

  useEffect(() => {
    const logConnection = () => {
      // eslint-disable-next-line no-console
      console.info('[Wallet] Manager connection:', {
        ...getWalletConnectionState(config),
        timestamp: new Date().toISOString(),
      })
    }
    logConnection()
    return watchAccount(config, { onChange: logConnection })
  }, [config])

  useEffect(() => {
    const currentConnection = config.state.current ? config.state.connections.get(config.state.current) : undefined

    normalizeEip1193ChainIdConnector(currentConnection?.connector).catch(() => undefined)
  }, [config, connector])

  return null
}

const WalletProvider: FC<Props> = ({ children, config }) => {
  return (
    <WagmiProvider config={config}>
      <Eip1193ChainIdNormalizer config={config} />
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  )
}
export default WalletProvider
